import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RootState } from 'store';

import { onUserLogout } from 'actions/user';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Menu, MenuItem, MenuItemIcon, User, Company, ChangeCompany } from './styles';

interface Props {
  open: boolean;
  onToggle: () => void;
  initialsRef: React.RefObject<HTMLDivElement>;
  name: string;
  email: string;
  companyName: string;
  countryName: string;
  countryCode?: string;
  hasCompanyBranches: boolean;
  branchCompanyLogged: boolean;
}

const DesktopProfileMenu = ({
  open,
  onToggle,
  initialsRef,
  name,
  email,
  companyName,
  countryName,
  countryCode,
  hasCompanyBranches,
  branchCompanyLogged,
}: Props) => {
  const { t } = useStoreTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const menuRef = useRef<HTMLDivElement>(null);
  const userData = useSelector((state: RootState) => state.user.accountResult);

  const isAdmin = userData?.type === 'admin';

  const handleClickAway = (event: MouseEvent) => {
    if (!menuRef.current) return;
    if (menuRef.current.contains(event.target as Node)) return;
    onToggle();
  };

  const handleCompanySettings = () => {
    history.push('/settings');
    onToggle();
  };
  const handleLogout = () => {
    dispatch(onUserLogout());
    history.push('/');
  };
  const handleProfile = () => {
    history.push('/travelerProfile');
    onToggle();
  };

  const handleCountrySelection = () => {
    history.push('/user-country-selection');
    onToggle();
  };

  useEffect(() => {
    if (open) document.addEventListener('mousedown', handleClickAway);
    else document.removeEventListener('mousedown', handleClickAway);
  });

  return (
    <Menu ref={menuRef} open={open}>
      <User>
        <User.Title> {t('profileMenu.user')}</User.Title>
        <User.Name>{name}</User.Name>
        <User.Email>{email}</User.Email>
      </User>
      <Company>
        <Company.Title> {t('profileMenu.company')}</Company.Title>
        <Company.Name>{companyName}</Company.Name>
        <Company.Country>{t(`countries.${countryCode}`)}</Company.Country>
        {hasCompanyBranches && hasCompanyBranches === true && (
          <ChangeCompany onClick={handleCountrySelection}>{t('profileMenu.changeCompany')}</ChangeCompany>
        )}
      </Company>
      <MenuItem onClick={handleProfile}>
        <MenuItemIcon src="/images/users.svg" />
        {t('profileMenu.myProfile')}
      </MenuItem>
      {isAdmin && (
        <MenuItem onClick={handleCompanySettings}>
          <MenuItemIcon src="/images/settings.svg" />
          {t('profileMenu.companySettings')}
        </MenuItem>
      )}
      <MenuItem onClick={handleLogout}>
        <MenuItemIcon src="/images/logout.svg" />
        {t('profileMenu.logout')}
      </MenuItem>
    </Menu>
  );
};

export default DesktopProfileMenu;
